import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  permissions: [],
  loading: false,
  error: null,
};

const permissionSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    storePermissions: (state, action) => {
      state.loading = false;
      state.permissions = action.payload.permissions;
    },
    clearPermissions: (state) => {
      state.permissions = [];
    },
  },
});

export const { 
  storePermissions, 
  clearPermissions 
} = permissionSlice.actions;

export const selectPermissions = (state) => state.permissions.permissions;

export default permissionSlice.reducer;